import "antd/es/input-number/style";
import _InputNumber from "antd/es/input-number";
import withFieldWrap from '../../utils/withFieldWrap';
export default withFieldWrap(_InputNumber);